export const config = {
    // Replace this with your actual backend URL
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    baseUrl: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000',
    defaultImage: '/placeholder-product.jpg'
};

/**
 * Build a full image URL from a backend-returned path.
 * - Accepts either a string path or undefined.
 * - If the path already starts with http(s) it is returned as-is.
 * - Replaces Windows backslashes with forward slashes.
 * - Ensures a leading slash before joining with baseUrl.
 */
export function buildImageUrl(imagePath) {
    if (!imagePath) return config.defaultImage;
    // If array was accidentally passed (some endpoints return arrays)
    if (Array.isArray(imagePath)) imagePath = imagePath[0];
    if (typeof imagePath !== 'string') return config.defaultImage;
    const trimmed = imagePath.trim();
    if (!trimmed) return config.defaultImage;
    // already absolute
    if (/^https?:\/\//i.test(trimmed)) return trimmed;
    // normalize backslashes to forward slashes
    let path = trimmed.replace(/\\/g, '/');
    // ensure leading slash
    if (!path.startsWith('/')) path = '/' + path;
    return `${config.baseUrl}${path}`;
}